import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export type VendorLifecycleMode = 'offboard' | 'reinstate' | 'suspend' | 'unsuspend';

export interface VendorOffboardDialogData {
  vendorName: string;
  mode: VendorLifecycleMode;
}

@Component({
  selector: 'app-vendor-offboard-dialog',
  templateUrl: './vendor-offboard-dialog.component.html',
  styleUrls: ['./vendor-offboard-dialog.component.css'],
})
export class VendorOffboardDialogComponent {
  form: FormGroup;
  isOffboard: boolean;
  showForce: boolean;
  confirmColor: 'warn' | 'primary';

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<VendorOffboardDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: VendorOffboardDialogData
  ) {
    this.isOffboard = data.mode === 'offboard';
    this.showForce = data.mode === 'offboard';
    this.confirmColor = data.mode === 'offboard' || data.mode === 'suspend' ? 'warn' : 'primary';
    const reasonRequired = data.mode === 'offboard' || data.mode === 'suspend';
    this.form = this.fb.group({
      reason: ['', reasonRequired ? Validators.required : []],
      force: [false],
    });
  }

  get title(): string {
    switch (this.data.mode) {
      case 'suspend':
        return 'Suspend vendor';
      case 'unsuspend':
        return 'Restore availability';
      case 'reinstate':
        return 'Reinstate vendor';
      default:
        return 'Offboard vendor';
    }
  }

  get confirmLabel(): string {
    switch (this.data.mode) {
      case 'suspend':
        return 'Suspend';
      case 'unsuspend':
        return 'Restore';
      case 'reinstate':
        return 'Reinstate';
      default:
        return 'Offboard';
    }
  }

  get reasonLabel(): string {
    switch (this.data.mode) {
      case 'suspend':
        return 'Reason for suspension';
      case 'unsuspend':
        return 'Note (optional)';
      case 'reinstate':
        return 'Reason for reinstatement';
      default:
        return 'Reason for offboarding';
    }
  }

  confirm(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.dialogRef.close(this.form.value);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
